import { combineReducers } from 'redux';
import anamneseReducer from './anamneseReducer';
import menuesReducer from './menuesReducer';
import menueWahlReducer from './menueWahlReducer';

const rootReducer = combineReducers({
    menues: menuesReducer,
    menueWahl: menueWahlReducer,
    anamnese: anamneseReducer,
})

export default rootReducer